var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerBottomButton } from '../../layout/answerbottom/AbfragerBottomButton';
import { AbfragerBottomLine } from '../../layout/answerbottom/AbfragerBottomLine';
import { QuestionTypeName } from '../../../../classes/learnware/LearnwareEnums';
let ShowQuestionAnswerBottomHistory = class ShowQuestionAnswerBottomHistory extends React.PureComponent {
    render() {
        const { question } = this.props;
        const left = (question.answer.answerInfo.indexInTray > 0 && (React.createElement(AbfragerBottomButton, { typ: 2, onClick: question.context.app.cycle.cycleNavigate.handlePreviousClick },
            React.createElement("i", { className: "fas fa-angle-left" }),
            " Zur\u00FCck"))) ||
            undefined;
        let right = (React.createElement(AbfragerBottomButton, { typ: 3, onClick: question.context.app.cycle.cycleNavigate.handleNextClick },
            "Fortsetzen ",
            React.createElement("i", { className: "fas fa-angle-right" })));
        if (question.questionType === QuestionTypeName.CycleEnd) {
            right = (React.createElement("div", null,
                React.createElement(AbfragerBottomButton, { typ: 5, onClick: question.context.app.directive.directiveStartNewCycle.startNewCycleByReload, style: { marginRight: 200 } }, "Neuen Lerndurchgang starten"),
                right));
        }
        return React.createElement(AbfragerBottomLine, { left: left, right: right });
    }
};
ShowQuestionAnswerBottomHistory = __decorate([
    observer
], ShowQuestionAnswerBottomHistory);
export { ShowQuestionAnswerBottomHistory };
